import { ButtonVariants } from '../../../../Atoms/Button';
import { PriceTable, TPRICE_TABLE_BODY } from '../../../../Common/price-table';
import { TPricingPlans } from '../../../../S/pricing/types';
import { ButtonWithAnchor } from '../sticky-button';

export const ViewPlanModalContent = ({
  trackLabel,
  plansList,
  priceTableData,
  buttonLink,
  priceMapData,
}: {
  trackLabel: string;
  plansList: Array<string>;
  priceTableData: TPRICE_TABLE_BODY[];
  buttonLink: string;
  priceMapData: Record<string, TPricingPlans>;
}): JSX.Element => {
  return (
    <div className="mx-auto w-full relative">
      <div className="p-5 sm:p-4 text-center">
        <div className="text-s-32 font-bold text-font-500 pb-1 sm:text-s-24">
          Self filing plans
        </div>
        <div className="text-base font-medium text-font-500 sm:text-s-14">
          Don ‘t worry, the plan will be selected automatically basis your
          income details.
        </div>
      </div>

      <div className="overflow-x-scroll">
        <PriceTable
          bodyData={priceTableData}
          plansList={plansList}
          priceMapData={priceMapData}
        />
      </div>

      <div className="flex justify-between sticky bottom-0 bg-white w-full left-0 right-0 p-6 gap-4 shadow-lg md:flex-col sm:flex-col">
        <div>
          <div className="text-s-24 font-medium text-grey-900 sm:text-s-18">
            Start Filing Now & Pay later at checkout.
          </div>
          <div className="text-base text-grey-700">
            {`Just add your details and we'll auto-select the
                        appropriate plan for you.`}
          </div>
        </div>
        <ButtonWithAnchor
          trackLabel={trackLabel}
          buttonText=" Start Filing"
          buttonVariant={ButtonVariants.bluefilled}
          className="text-base px-12"
          buttonLink={buttonLink}
        />
      </div>
    </div>
  );
};
